<template>
    <v-card>
        <v-card-title>Warenkorb</v-card-title>
        <v-divider />

        <v-card-text v-if="cart && cart.length">
            <v-data-table
                :items="cart" 
                :headers="headers" 
                :items-per-page="-1"
                hide-default-footer
                dense
            >
                <template v-slot:item.name="{ item }">
                    <a @click.stop="toggleItemDetailDialog(item.itemnum)">
                        <b>{{ item.itemnum }}</b><br>
                        {{ item.name }}
                    </a>
                    <div v-if="item.extdata && item.extdata.e_VPE"><i>VPE: {{ item.extdata.e_VPE.replace('*', '') }}</i></div>
                </template>

                <template v-slot:item.amount="{ item }">
                    <ItemQuantity :item="item" />
                </template>

                <template v-slot:item.price="{ item }">
                    {{ toPrice(item.sellingprice) }}
                </template>

                <template v-slot:item.totalPrice="{ item }">
                    {{ toPrice(item.totalprice) }}
                </template>

                <template v-slot:item.action="{ item }">
                    <v-btn icon @click.stop="removeItemFromCart(item)">
                        <v-icon color="red">mdi-close</v-icon>
                    </v-btn>
                </template>

                <template v-slot:body.append>
                    <tr v-if="totalDiscount > 0" class="d-none d-sm-table-row">
                        <td></td>
                        <td></td>
                        <td class="text-right">Nachlass</td>
                        <td class="text-right">-{{ toPrice(totalDiscount) }}</td>
                        <td></td>
                    </tr>
                        
                    <tr class="d-none d-sm-table-row">
                        <td></td>
                        <td></td>
                        <td class="text-right font-weight-bold">Summe (netto)</td>
                        <td class="text-right font-weight-bold">{{ toPrice(totalNet) }}</td>
                        <td></td>
                    </tr>

                    <tr v-if="totalDiscount > 0" class="d-table-row d-sm-none">
                        <td class="text-right font-weight-bold">Nachlass: -{{ toPrice(totalDiscount) }}</td>
                    </tr>
                        
                    <tr class="d-table-row d-sm-none">
                        <td class="text-right font-weight-bold">Summe (netto): {{ toPrice(totalNet)}}</td>
                    </tr>                    
                </template>
            </v-data-table>
        </v-card-text>

        <v-card-text v-else class="mt-5">Sie haben keine Artikel in Ihrem Warenkorb.</v-card-text>

        <v-divider />
        <v-card-actions>
            <v-btn outlined :disabled="!cart.length" @click.stop="deleteCart()" text>
                <v-icon color="red">mdi-close</v-icon>
                leeren
            </v-btn>
            <v-spacer />
            <v-btn outlined color="primary" :disabled="!cart.length" @click="closeCartDialog()" to="/checkout">
                Zum Checkout
            </v-btn>
        </v-card-actions>

        <v-dialog v-model="itemDetailDialog" max-width="800">
            <v-card class="mb-n1" elevation="0" tile>
                <v-card-actions>
                    <v-spacer />
                    <v-btn icon @click.stop="itemDetailDialog = !itemDetailDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
            <ItemDetailView :itemNumber.sync="itemNumber" />
        </v-dialog>
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import ItemQuantity from "@/modules/store/components/cart/ItemQuantity";
import ItemDetailView from "@/modules/store/components/item/ItemDetailView";

export default {
    name: "Cart",

    props: ["cartModal", "closeCart"],

    components: {
        ItemQuantity,
        ItemDetailView,
    },

    data: () => ({
        itemNumber: null,
        itemDetailDialog: false,
        headers: [
            {
                sortable: false,
                align: 'start',
                text: 'Produkt',
                value: 'name',
            },
            {
                sortable: false,
                text: 'Menge',
                value: 'amount'
            },
            {
                sortable: false,
                align: 'end',
                text: 'Einzelpreis',
                value: 'price'
            },
            {
                sortable: false,
                align: 'end',
                text: 'Gesamtpreis',
                value: 'totalPrice'
            },
            {
                sortable: false,
                align: 'end',
                text: '',
                value: 'action'
            }
        ]
    }),

    computed: {
        ...mapGetters("cart", ["cart"]),
        ...mapGetters("account", ["selectedAccount"]),

        totalNet() {
            return _.sumBy(this.cart, "totalprice")
        },

        totalDiscount() {
            return _.sumBy(this.cart, "totaldiscount")
        }
    },

    methods: {
        ...mapActions("cart", ["removeItemFromCart", "deleteCart"]),

        closeCartDialog() {
            this.closeCart();
        },

        toPrice(sellingprice) {
            return parseFloat(sellingprice).toFixed(2).replace('.',',') + "€";
        },

        toggleItemDetailDialog(itemNumber) {
            this.itemNumber = itemNumber;
            this.itemDetailDialog = true;
        }
    }
}
</script>
